import { breakpointsList } from './breakpoints';
import { constantUnit } from './constants';
export var enumerate = {
  breakpoint: breakpointsList,
  width: 1440,
  constantUnit: constantUnit
};